import React, { Fragment, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { Link } from "react-router-dom";

const menus = [
    {
        id: 1,
        title: 'Home',
        link: '/',
    },
    {
        id: 3,
        title: 'Company',
        link: '/',
        submenu: [
            {
                id: 322,
                title: 'About Us',
                link: '/about'
            },
            {
                id: 345,
                title: 'Blog',
                link: '/blog'
            },
           
            {
                id: 347,
                title: 'Career',
                link: '/career'
            }
        ]
    },
    {
        id: 7,
        title: 'Our Work',
        link: '/',
        submenu: [
            {
                id: 61,
                title: 'Portfolio',
                link: '/portfolio'
            },
            {
                id: 63,
                title: 'Case Study',
                link: '/case-study'
            }
        ]
    },
    {
        id: 4,
        title: 'Services',
        link: '/service',
        submenu: [
            {
                id: 41,
                title: 'Web Development',
                link: '/web-development-services'
            },
            {
                id: 42,
                title: 'App Development',
                link: '/app-development-services'
            },
            {
                id: 42,
                title: 'E-commerce Solutions',
                link: '/e-commerce-solutions-services'
            },
            {
                id: 42,
                title: 'Custom Software',
                link: '/custom-software-services'
            },
            {
                id: 42,
                title: 'Graphic Designing',
                link: '/graphic-design-services'
            },
            {
                id: 42,
                title: 'UI/UX Design',
                link: '/ui-ux-development-services'
            },
            {
                id: 42,
                title: 'Video Editing',
                link: '/video-editing-services'
            },
            {
                id: 42,
                title: 'SEO',
                link: '/seo-services'
            },
            {
                id: 42,
                title: 'SMO',
                link: '/smo-services'
            }
        ]
    },
    {
        id: 5,
        title: 'Industries',
        link: '/',
        submenu: [
            {
                id: 41,
                title: 'Healthcare',
                link: '/industries/healthcare'
            },
            {
                id: 42,
                title: 'Education & E-Learning',
                link: '/industries/education'
            },
            {
                id: 42,
                title: 'Finance',
                link: '/industries/finance'
            },
            // {
            //     id: 42,
            //     title: 'Real Estate',
            //     link: '/industries/real-estate'
            // },
            {
                id: 42,
                title: 'Legal & Consultancy',
                link: '/industries/legal-consultancy'
            },
            {
                id: 42,
                title: 'Logistic',
                link: '/industries/logistics'
            },
            {
                id: 42,
                title: 'Insurance',
                link: '/industries/insurance'
            },
            {
                id: 42,
                title: 'Manufacturing',
                link: '/industries/manufacturing'
            },
            {
                id: 42,
                title: 'Travel',
                link: '/industries/travel'
            },
            {
                id: 42,
                title: 'Retail',
                link: '/industries/retail'
            },
            {
                id: 42,
                title: 'Construction',
                link: '/industries/construction'
            },
            {
                id: 42,
                title: 'Sports',
                link: '/industries/sports'
            },
             {
                id: 42,
                title: 'Marketplace',
                link: '/industries/marketplace'
            },
            {
                id: 42,
                title: 'Beauty & Lifestyle',
                link: '/industries/beauty-lifestyle'
            },
            {
                id: 42,
                title: 'On Demand',
                link: '/industries/on-demand'
            },
            
        ]
    },
   
    {
        id: 8,
        title: 'Contact',
        link: '/contact',
    }


]

const MobileMenu = () => {

    const [openId, setOpenId] = useState(0);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <ul className="main_menu_list clearfix">
            {menus.map((item, mn) => {
                return (
                    <ListItem className={item.id === openId ? 'active' : null} key={mn}>
                        {item.submenu ?
                            <Fragment>
                                <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>{item.title}
                                    <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                </p>
                                <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                    <List className="subMenu">
                                        <Fragment>
                                            {item.submenu.map((submenu, i) => {
                                                return (
                                                    <ListItem key={i}>
                                                        <Link onClick={ClickHandler} className="active"
                                                            to={submenu.link}>{submenu.title}</Link>
                                                    </ListItem>
                                                )
                                            })}
                                        </Fragment>
                                    </List>
                                </Collapse>
                            </Fragment>
                            : <Link className="active"
                                to={item.link}>{item.title}</Link>
                        }
                    </ListItem>
                )
            })}
        </ul>
    )
}

export default MobileMenu;